import axios from 'axios'

import { useAuthToken } from '@tribeplatform/react-sdk/hooks'

import { RuntimeConfigs } from '../config'
import { getDomainInfo } from '../utils/domain'

export const useSupportCommunitySso = () => {
  const {
    data: { accessToken, networkPublicInfo },
  } = useAuthToken()
  const { subfolder } = getDomainInfo(networkPublicInfo)

  const getSupportCommunityUrl = async () => {
    try {
      const response = await axios.get(
        `${subfolder || ''}/api/auth/community`,
        {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        },
      )

      return response?.data?.redirect_uri
    } catch (e) {
      console.warn('Could not fetch Bettermode community token')
    }
    return RuntimeConfigs.SUPPORT_COMMUNITY_URL
  }

  return {
    getSupportCommunityUrl,
  }
}
